import { render } from "./LandingBlockHowWeMakeMoney.vue?vue&type=template&id=278409f3&scoped=true&lang=pug"
import script from "./LandingBlockHowWeMakeMoney.vue?vue&type=script&lang=js"
export * from "./LandingBlockHowWeMakeMoney.vue?vue&type=script&lang=js"

import "./LandingBlockHowWeMakeMoney.vue?vue&type=style&index=0&id=278409f3&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278409f3"]])

export default __exports__